module.exports = __webpack_public_path__ + "img/out_transaction1.bf341664.svg";